import { ELearningOpener } from './../e-learning/e-learning-opener';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';

import { UrlBuilder } from '../core';
import { DocumentDownloader, CategoryNaturalKey, Category } from '../documents';
import { OnInit, ChangeDetectionStrategy, Component } from '@angular/core';
import { LinkByDate, LinkByDocument } from '../documents/models/dlLink';

@Component({
    selector: 'mail-links',
    template: require('./mail-links.component.html'),
    styles: [require('./mail-links.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MailLinksComponent implements OnInit {
    constructor(
        private documentDownloader: DocumentDownloader,
        private elearningOpener: ELearningOpener,
        private route: ActivatedRoute,
        private urlBuilder: UrlBuilder) {
    }

    public async ngOnInit() {
        await this.processNotificationLink();
    }

    private processNotificationLink() {
        const categoryNaturalKey: CategoryNaturalKey = this.route.snapshot.queryParams['category'];
        const urlDate = this.route.snapshot.queryParams['date'];
        const documentId: string = this.route.snapshot.queryParams['documentId'];

        if (categoryNaturalKey && (urlDate || documentId)) {
            if (urlDate) {
                const date = moment(urlDate);
                this.downloadCategoryDocuments(new LinkByDate(categoryNaturalKey, date));
            } else {
                const link = new LinkByDocument(categoryNaturalKey, documentId);
                if (Category.isELearningCategory(categoryNaturalKey)) {
                    this.openElearning(link);
                } else {
                    this.downloadDocument(link);
                }
            }
        } else {
            console.warn('invalid notification link');
        }

        this.urlBuilder.esa().navigate();
    }

    private async downloadDocument(link: LinkByDocument) {
        await this.documentDownloader.downloadDocumentLink(link);
    }

    private async downloadCategoryDocuments(link: LinkByDate) {
        await this.documentDownloader.downloadCategoryDocuments(link);
    }

    private async openElearning(link: LinkByDocument) {
        await this.elearningOpener.openFromNotification(link);
    }
}